import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { SearchOutlined, ExportOutlined } from '@ant-design/icons'
import { Button, Input, Tag } from 'antd'
import useParams from '../../hook/useParams'
import { SearchWrapper, WhiteWrapper } from './consumer.styled'
import { useSelector } from 'react-redux'
import MainTable from '../../components/Basic/MainTable'
import { fetchConsumerList } from '../../apis/consumer360'
import { fetchPii } from '../../apis/source'

function Consumer360List (props) {
  const { adminMode } = props
  const { t: ln_t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname } = location || {}
  const user = useSelector((state) => state.user)
  const { nowGroup, nowBrand } = user || {}
  const params = useParams({ startIndex: location?.state?.page || 1, includes: 'group', groupId: adminMode ? undefined : nowGroup }, false)
  const { handleFetchParams, fetchParams, handleTableParams, setReady } = params
  const [header, setHeader] = useState([])

  const apiFunc = async () => fetchConsumerList(nowBrand, fetchParams).then(res => {
    const { data: originalData = [] } = res || {}
    const data = originalData.map(({ consumerId, pii }) => ({ consumerId, ...pii }))
    return { ...res, data }
  })
  const columns = [
    ...header,
    {
      title: ln_t('util.actions'),
      dataIndex: 'consumerId',
      render: (id, data) => (
        <Button
          size="small"
          icon={<ExportOutlined />}
          onClick={() => navigate(`${pathname}/detail`, { state: { data: { ...data, brandId: nowBrand }, page: fetchParams?.startIndex } })}
        >
          {ln_t('target.viewDetails')}
        </Button>
      )
    }
  ]

  const getHeader = async () => {
    const res = await fetchPii(user?.nowBrand, { maxResults: 999 })
    if (res?.status === 200) {
      setHeader(res?.data?.map(({ value }) => ({
        title: value,
        dataIndex: value.toLowerCase(),
        render: e => Array.isArray(e) && e?.length > 1 ? e?.map(item => <Tag key={item}>{item}</Tag>) : e
      })))
    }
  }

  useEffect(() => {
    getHeader()
    handleTableParams('add', { showQuickJumper: true })
    setReady(true)
  }, [])

  return (
    <WhiteWrapper>
      <h3>{ln_t('consumer.consumer360')}</h3>
      <SearchWrapper>
        <Input.Search
          allowClear
          style={{ width: '400px' }}
          placeholder={ln_t('util.search')}
          onSearch={e => handleFetchParams('init', { search: e ? `${e}` : null })}
          enterButton={<Button type="primary" size="small" icon={<SearchOutlined />} />}
        />
      </SearchWrapper>

      <MainTable
        columns={columns}
        rowKey="consumerId"
        apiFunc={apiFunc}
        params={params}
        startIndexAsPage={true}
        disabledRow={record => !record.previewCount || !record.status}
      />
    </WhiteWrapper>
  )
}

export default Consumer360List
